import { useQuery } from '@tanstack/react-query';

import type { Site } from '../context/types';
import { getDiscoveryService } from '../services/discoveryService';
import { useManifest } from './useManifest';

export function useSitePath(clientName: string, site: Site | undefined) {
  const discoveryService = getDiscoveryService()!;
  const { data } = useManifest(clientName);
  let etag: string | undefined = '';
  if (site) {
    etag = discoveryService.getSitePathEtag(site?.id);
  }
  return useQuery({
    staleTime: Infinity,
    enabled: !!data && !!site,
    queryKey: ['path', site?.id, clientName, etag],
    queryFn: async () => discoveryService.getSitePath(site!.id),
  });
}
